<template>
  <div class="p-4 bg-white shadow-md rounded-lg">
    <el-row :gutter="20" class="mb-6">
      <!-- Гарчигаар хайх -->
      <el-col :span="7">
        <label class="block text-gray-700 font-medium">Гарчигаар хайх</label>
        <el-input v-model="search" placeholder="Купон кодоор хайх" class="mt-2">
          <el-button slot="prepend" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>

      <!-- Хайх суваг -->
      <el-col :span="3">
        <label class="block text-gray-700 font-medium">Хайх суваг</label>
        <el-select v-model="channel" class="mt-2 w-full">
          <el-option value="ALL" label="Both"></el-option>
          <el-option value="TOKTOK" label="TOKTOK"></el-option>
          <el-option value="ECOMMERCE" label="TOKTOKMALL"></el-option>
        </el-select>
      </el-col>

      <!-- Статус -->
      <el-col :span="3">
        <label class="block text-gray-700 font-medium">Статус</label>
        <el-select v-model="status" class="mt-2 w-full">
          <el-option value="all" label="All"></el-option>
          <el-option value="active" label="Active"></el-option>
          <el-option value="expired" label="Expired"></el-option>
        </el-select>
      </el-col>

      <!-- Үүсгэсэн -->
      <el-col :span="3">
        <label class="block text-gray-700 font-medium">Үүсгэсэн</label>
        <el-select v-model="selectedUser" class="mt-2 w-full">
          <el-option value="" label="Бүгд"></el-option>
          <el-option v-for="(user, index) in users" :key="index" :value="user" :label="user"></el-option>
        </el-select>
      </el-col>

      <!-- Төрөл -->
      <el-col :span="3">
        <label class="block text-gray-700 font-medium">Төрөл</label>
        <el-select v-model="type" class="mt-2 w-full">
          <el-option value="" label="Бүгд"></el-option>
          <el-option value="AUTO" label="AUTO"></el-option>
          <el-option value="DISCOUNT_CODE" label="CODE"></el-option>
        </el-select>
      </el-col>

      <!-- Хайх & Нэмэх товч -->
      <el-col :span="3" class="flex items-end">
        <el-button type="primary" class="w-full" @click="doFilter">Хайх</el-button>
      </el-col>
      <el-col :span="2" class="flex items-end">
        <el-button type="success" class="w-full" @click="addCoupon" :disabled="isDisable">Нэмэх</el-button>
      </el-col>
    </el-row>

    <!-- Хүснэгт -->
    <Table :discounts="discounts" :loading="loading"></Table>

    <!-- Хуудаслах -->
    <el-pagination
      @current-change="(val) => { page = val; doFilter(); }"
      class="text-right mt-6"
      background
      :current-page="currentPage"
      :page-size="size"
      layout="total, prev, pager, next"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>

<script>
import services from '@/helpers/services'
import Table from './components/table.vue'
import { getGroups } from '@/utils/auth.js'
export default {
  name: 'discountList',
  components: {
    Table
  },
  data () {
    return {
      page: 1,
      totalCount: 0,
      discounts: [],
      loading: false,
      size: 10,
      search: '',
      channel: 'ALL',
      status: 'all',
      users: [],
      type: '',
      selectedUser: '',
      chooseCouponVisible: false,
      group: [],
      isDisable: false
    }
  },
  async mounted () {
    this.getDiscounts()
  },
  methods: {
    doFilter () {
      this.$router.push({
        name: 'discounts',
        query: {
          page: this.page,
          search_text: this.search,
          channel: this.channel,
          user: this.selectedUser,
          type: this.type,
          status: this.status
        }
      })
      this.getDiscounts()
    },
    async getDiscounts () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
      const query = '?search_text=' + this.search + '&from=' + this.size * (this.page - 1) + '&size=' + this.size + '&type=' + this.type + '&status=' + this.status + '&channel=' + this.channel + '&adminFilter=' + this.selectedUser
      this.loading = true
      services.getDiscounts(query).then(response => {
        this.totalCount = response.total
        this.discounts = response.discounts
        this.users = response.created_admins
        this.loading = false
      })
    },
    async addCoupon () {
      this.$router.push({ name: 'addDiscount' })
    },
    closeDialog () {
      this.chooseCouponVisible = false
    }
  },
  computed: {
    currentPage () {
      return parseInt(this.$route.query.page)
    }
  }
}
</script>
<style scoped>
.txtColor {
  color:grey;
}
</style>
